import React from 'react';
import { IconDelete, IconArrowForward } from './icons';
import './StorageMeter.scss';

const formatBytes = (bytes) => {
  if (!bytes || bytes < 0) return '0 B';
  const units = ['B', 'KB', 'MB', 'GB', 'TB'];
  const i = Math.min(units.length - 1, Math.floor(Math.log(bytes) / Math.log(1024)));
  return `${(bytes / Math.pow(1024, i)).toFixed(i === 0 ? 0 : 1)} ${units[i]}`;
};

const StorageMeter = ({ summary, compact = false, onUpgradeClick }) => {
  if (!summary) {
    return (
      <div className={`storage-meter ${compact ? 'is-compact' : ''} is-loading`} aria-busy="true">
        <div className="storage-meter__top">
          <span className="storage-meter__skel storage-meter__skel--label" />
          <span className="storage-meter__skel storage-meter__skel--pct" />
        </div>
        <div className="storage-meter__bar">
          <div className="storage-meter__fill is-shimmer" />
        </div>
      </div>
    );
  }

  const { usage = 0, limit, isUnlimited, usagePercentage = 0, trashedSize = 0 } = summary;
  const pct = Math.min(100, Math.max(0, usagePercentage));
  const level = pct >= 100 ? 'over' : pct >= 80 ? 'warn' : 'ok';
  const displayPct = isUnlimited
    ? null
    : pct === 0
    ? '0%'
    : pct < 1
    ? '< 1%'
    : `${pct.toFixed(pct < 10 ? 1 : 0)}%`;

  return (
    <div className={`storage-meter ${compact ? 'is-compact' : ''} is-${level}`}>
      <div className="storage-meter__top">
        <div className="storage-meter__usage">
          <strong>{formatBytes(usage)}</strong>
          <span className="storage-meter__divider">of</span>
          <span className="storage-meter__limit">
            {isUnlimited ? 'Unlimited' : formatBytes(limit)}
          </span>
        </div>
        {displayPct !== null && (
          <span className="storage-meter__pct">{displayPct}</span>
        )}
      </div>

      <div className="storage-meter__bar">
        <div
          className="storage-meter__fill"
          style={{ width: isUnlimited ? '100%' : `${Math.max(2, pct)}%` }}
        />
      </div>

      {!compact && (trashedSize > 0 || (level !== 'ok' && !isUnlimited && onUpgradeClick)) && (
        <div className="storage-meter__bottom">
          {trashedSize > 0 && (
            <span className="storage-meter__trashed">
              <IconDelete size={14} />
              {formatBytes(trashedSize)} in Trash
            </span>
          )}
          {!isUnlimited && level !== 'ok' && onUpgradeClick && (
            <button className="storage-meter__upgrade" onClick={onUpgradeClick}>
              Upgrade
              <IconArrowForward size={14} />
            </button>
          )}
        </div>
      )}
    </div>
  );
};

export { formatBytes };
export default StorageMeter;
